import styled from 'styled-components';

export const StyledScrollPointerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  img {
    height: ${({ radius }) => (radius/2)}px;
    animation: blink 1s linear infinite;
  }

  @keyframes blink {
    0% {
        opacity:1;
    }
    50% {
        opacity:0;
    }
    100% {
        opacity:1;
    }
`;
